(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const profileColumns = document.querySelectorAll('.our-experts__profile-column--has-popup');

        profileColumns.forEach(function (column) {
            column.style.cursor = 'pointer';
            const index = column.getAttribute('data-popup-index');
            const overlay = document.querySelector(
                '.our-experts__popup-overlay[data-popup-target="' + index + '"]'
            );

            if (!overlay) return;

            column.addEventListener('click', function () {
                overlay.classList.add('our-experts__popup-overlay--active');
                overlay.setAttribute('aria-hidden', 'false');
                document.body.style.overflow = 'hidden';
            });

            var closeBtn = overlay.querySelector('.our-experts__popup-close');
            if (closeBtn) {
                closeBtn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    closePopup(overlay);
                });
            }

            overlay.addEventListener('click', function (e) {
                if (e.target === overlay) {
                    closePopup(overlay);
                }
            });
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                var activeOverlay = document.querySelector('.our-experts__popup-overlay--active');
                if (activeOverlay) {
                    closePopup(activeOverlay);
                }
            }
        });

        function closePopup(overlay) {
            overlay.classList.remove('our-experts__popup-overlay--active');
            overlay.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }
    });
})();
